(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("AlarmsController", AlarmsController);

  /** @ngInject */
  function AlarmsController(
    $scope,
    messageActions,
    deviceActions,
    AlarmsViewModel,
    brand
  ) {
    var vm = this;

    vm.messagesPromise = null;
    vm.messages = new AlarmsViewModel();
    vm.getAllMessages = refresh;
    vm.brand = brand;

    // Convert time (time zone offset)
    // var offset = vm.messages.alarmsFrom.getTimezoneOffset() * (-60000);

    vm.pageChanged = function(page, limit) {
      vm.messages.alarmsPaginationChanged(page, limit);
      refresh();
    };

    vm.sortChanged = function(order) {
      vm.messages.alarmsOrderingChanged(order);
      refresh();
    };

    vm.itemNumbering = function(item) {
      if (vm.messages.alarmsPage === 1) {
        return item + 1;
      } else if (vm.messages.alarmsPage === 2) {
        return item + 11;
      } else {
        return (vm.messages.alarmsPage - 1) * 10 + (item + 1);
      }
    };

    vm.searchMessages = function() {
      vm.messages.alarmsPage = 1;
      refresh();
    };

    init();

    function init() {
      $scope.$on("destroy", function() {
        if (vm.messages !== null) {
          vm.messages.destroy();
        }
      });

      vm.messages.onMessagesFilterChanged = refresh;

      deviceActions.getAllDevices().then(function(devicesData) {
        vm.messages.refreshFacilities(devicesData);
        refresh();
      });

      refreshActiveAlarms();
    }

    function refresh() {
      var deviceSerial =
        vm.messages.selectedFacilitySerial !== "-1"
          ? vm.messages.selectedFacilitySerial
          : null;

      vm.promise = messageActions
        .getAllMessages(
          deviceSerial,
          vm.messages.alarmsFrom.getTime(),
          vm.messages.alarmsTo.getTime(),
          vm.messages.alarmsPage - 1,
          vm.messages.alarmsPageSize,
          vm.messages.alarmsOrderBy,
          vm.messages.alarmsOrder
        )
        .then(
          function(messagesData) {
            vm.messages.refreshMessages(messagesData);
          },
          function() {
            //todo error handling
          }
        );
    }

    function refreshActiveAlarms() {
      messageActions.getAlarmMessages().then(function(alarmList) {
        vm.messages.activeAlarmsList = alarmList;
      });
    }
  }
})();
